/**
 * Shefira's scenes (ADR 0067): the dragon is no zone entity but an effect of
 * the client, played for the one player who turns in the quest that shows
 * her, like the teleport's veil. The server only names the scene.
 */
/**
 * `shefira-shadow`: her shadow alone passes over (la Ferme calcinée);
 * `shefira-breach`: the whole scene (la Brèche); `shefira-flight`: wounded,
 * Ser Givrecoeur's sword in her flank, she flees to the summits (the story's
 * end in her Aire, ADR 0068 §4), sent by the room when the stand is won.
 */
export const CINEMATIC_IDS = ['shefira-shadow', 'shefira-breach', 'shefira-flight'];
/** The quest turned in → the scene its turner-in sees. */
export const QUEST_CINEMATICS = {
    'meadow-dragon-farm': 'shefira-shadow',
    'snow-breach': 'shefira-breach',
};
export function cinematicFor(questId) {
    return Object.hasOwn(QUEST_CINEMATICS, questId) ? QUEST_CINEMATICS[questId] : undefined;
}
//# sourceMappingURL=cinematics.js.map